import { useTheme } from '../../ThemeContext';

export default function AlertBox({ children, variant = 'error' }) {
  const { t } = useTheme();
  const isSuccess = variant === 'success';

  return (
    <div style={{
      backgroundColor: isSuccess ? t.successBg : t.errorBg,
      border: `1px solid ${isSuccess ? t.success : t.error}`,
      color: isSuccess ? t.success : t.error,
      padding: '12px',
      borderRadius: '8px',
      marginBottom: '16px',
      fontSize: '14px',
      fontFamily: 'Poppins, sans-serif',
    }}>
      {children}
    </div>
  );
}
